import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconSelect = memo(
  forwardRef((props, ref) => (
    <SvgIcon {...props} ref={ref} viewBox="0 0 6 10" data-fill-none>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.16766 0.52903C2.90011 0.201261 2.38185 0.201261 2.11424 0.52903L0.142905 2.94367C-0.199897 3.36356 0.112768 3.97689 0.669616 3.97689H4.61235C5.16917 3.97689 5.48183 3.36356 5.13902 2.94367L3.16766 0.52903ZM2.11477 9.47134C2.38232 9.79911 2.90058 9.79911 3.16819 9.47134L5.13949 7.05671C5.4823 6.63679 5.16964 6.02341 4.61281 6.02341H0.670104C0.113263 6.02341 -0.199409 6.63679 0.143393 7.05671L2.11477 9.47134Z"
        fill="#2F393E"
      />
    </SvgIcon>
  ))
);
